import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { AdditionalContentPage, MixedOrderItem } from 'src/app/model/page/additional-content-page';
import { AdditionalContentPageSection } from 'src/app/model/section/additional-content-page-section';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-additional-content-page',
  templateUrl: './additional-content-page.component.html',
  styleUrls: ['./additional-content-page.component.scss']
})
export class AdditionalContentPageComponent implements OnInit {
  pageTitle = '';

  additionalContentPage: AdditionalContentPage = {} as AdditionalContentPage;

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'additional-content') {
        this.additionalContentPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => {
      this.pageTitle = params['pageTitle'] || this.activatedRoute.snapshot.data['pageTitle'];

      const query = { 'fields.title': this.pageTitle };
      this.contentfulService.getPageContentResponse(query).then((additionalContentPageEntries) => {
        this.additionalContentPage.introductionSections = [];
        this.additionalContentPage.belowNoteSections = [];
        this.additionalContentPage.imageSections = [];
        this.additionalContentPage.accordianSections = [];
        this.additionalContentPage.noteSections = [];
        this.additionalContentPage.tableSections = [];
        this.additionalContentPage.additionalSectionCardsAboveTable = [];
        this.additionalContentPage.additionalSectionCardsBelowTable = [];
        this.additionalContentPage.additionalCardCarousel = [];
        this.additionalContentPage.emergencyBanners = [];
        this.additionalContentPage.ribbonTileSections = [];
        this.additionalContentPage.orderSections = [];
        this.additionalContentPage.mixedOrderSections = [];

        this.mapHtmlTitle(additionalContentPageEntries.items);
        this.mapBanner(additionalContentPageEntries.includes.Entry);
        this.mapEntryToSection(additionalContentPageEntries.includes.Entry);
        this.mapPageInfo(additionalContentPageEntries.items);
        this.mapNoteSection(additionalContentPageEntries.includes.Entry);
        this.mapTableSection(additionalContentPageEntries.includes.Entry);
        this.mapImage(additionalContentPageEntries.includes.Asset);
        this.mapCards(additionalContentPageEntries.includes.Entry);
        this.mapEmergencyBanners(additionalContentPageEntries.includes.Entry);
      });
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.additionalContentPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(additionalContentPageEntries: Entry<any>[]) {
    additionalContentPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];

    this.additionalContentPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string
    };
  }

  private mapEmergencyBanners(emegencyPageEntries: Entry<any>[]) {
    emegencyPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToEmergencyBanner(entry);
      });
  }

  private mapEntryToEmergencyBanner(entry: Entry<any>) {
    this.additionalContentPage.emergencyBanners.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: '',
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
    this.additionalContentPage.emergencyBanners.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    this.additionalContentPage.banner.lastUpdated = items.pop()?.fields['lastUpdated'] as string;
  }


   private mapImage(assets: Entry<any>[]) { 

        const asset = assets.filter((asset) =>{
            let title = asset.fields['title'] as string;    
            return title.split('#').pop() === 'imageSection'
    }); 
        let myImage:any=asset[0]?.fields;
        this.additionalContentPage.image = myImage?.file?.url; 
         
      }

  private mapNoteSection(additionalContentPageEntries: Entry<any>[]) {
    additionalContentPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        if (entry.fields['group'] === 'note') {
          this.mapEntryToNoteSection(entry);
        }
      });
  }

  private mapEntryToNoteSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.additionalContentPage.noteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
    this.additionalContentPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(additionalContentPageEntries: Entry<any>[]) {
    additionalContentPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'introduction':
            this.mapEntryToIntroductionSection(entry);
            break;
          case 'section':
            this.mapEntryToOrderSection(entry);
            break;
          case 'section-below-table':
            this.mapEntryTobelowNoteSections(entry);
            break;
          case 'imageSection':
            this.mapEntryToImageSections(entry);
            break;
          case 'accordion':
            this.mapEntryToAccordionSection(entry);
            break;
          case 'ribbon-tile':
            this.mapEntryToRibbonTileSection(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });
    this.additionalContentPage.mixedOrderSections.sort((a, b) => a.order - b.order);
  }

  private mapCards(additionalPageEntries: Entry<any>[]) {
    additionalPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        switch (entry.fields['category']) {
          case 'card-above-text-area':
            this.mapEntryToAdditionalPageContentCardAboveTable(entry);
            break;
          case 'card-below-text-area':
            this.mapEntryToAdditionalPageContentCardBelowTable(entry);
            break;
          case 'card-carousel-text-area':
            this.mapCardCarouselSection(entry);
            break;
          default:
        }
      });
    this.additionalContentPage.additionalSectionCardsAboveTable.sort((a, b) => a.order - b.order);
    this.additionalContentPage.additionalSectionCardsBelowTable.sort((a, b) => a.order - b.order);
    this.additionalContentPage.additionalCardCarousel.sort((a, b) => a.order - b.order);
  }

  private mapEntryToCard(entry: Entry<any>) {
    let headerImage: any = entry.fields['headImage'];
    let pageBody: any = entry.fields['body'] as string;
    return {
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      headImage: headerImage.fields?.file?.url,
      headIconClass: entry.fields['headIconClass'] as string,
      body: pageBody.content[0].content[0].value,
      url: entry.fields['url'] as string,
      buttonText: entry.fields['buttonText'] as string
    };
  }

  private mapEntryToAdditionalPageContentCardAboveTable(entry: Entry<any>) {
    this.additionalContentPage.additionalSectionCardsAboveTable.push(this.mapEntryToCard(entry));
  }

  private mapEntryToAdditionalPageContentCardBelowTable(entry: Entry<any>) {
    this.additionalContentPage.additionalSectionCardsBelowTable.push(this.mapEntryToCard(entry));
  }

  private mapCardCarouselSection(entry: Entry<any>) {
    this.additionalContentPage.additionalCardCarousel.push(this.mapEntryToCard(entry));
  }

  private buildSectionFromEntry(entry: Entry<any>, includeNotes = false): AdditionalContentPageSection {
    const title = (entry.fields['title'] as string).split('#').pop() || '';
    const section: AdditionalContentPageSection = {
      title,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string
    };
    if (includeNotes) {
      section.noteSections = this.additionalContentPage.noteSections.filter(
        (noteSection) => noteSection.category === entry.fields['title']
      );
    }
    return section;
  }

  private mapEntryToIntroductionSection(entry: Entry<any>) {
    this.additionalContentPage.introductionSections.push(this.buildSectionFromEntry(entry, true));
    this.additionalContentPage.introductionSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToOrderSection(entry: Entry<any>) {
    this.additionalContentPage.mixedOrderSections.push({
      type: 'section',
      order: entry.fields['order'] as number,
      section: this.buildSectionFromEntry(entry, true)
    });
  }

  private mapEntryToImageSections(entry: Entry<any>) {
    this.additionalContentPage.imageSections.push(this.buildSectionFromEntry(entry));
    this.additionalContentPage.imageSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryTobelowNoteSections(entry: Entry<any>) {
    this.additionalContentPage.belowNoteSections.push(this.buildSectionFromEntry(entry, true));
    this.additionalContentPage.belowNoteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToAccordionSection(entry: Entry<any>) {
    this.additionalContentPage.accordianSections.push(this.buildSectionFromEntry(entry));
    this.additionalContentPage.accordianSections.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(additionalContentPageEntries: Entry<any>[]) {
    additionalContentPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }
  private mapEntryToTableSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();


    this.additionalContentPage.tableSections.push({
      title:pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string,
      noteSections: this.additionalContentPage.noteSections.filter((noteSection) => noteSection.category === entry.fields['title'])
    });
    this.additionalContentPage.tableSections.sort((a, b) => a.order - b.order);
  }

    private mapEntryToRibbonTileSection(entry: Entry<any>) {
    let tBody: string[] = [];
    let pageBody=entry.fields['body'] as string;
    pageBody?.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.additionalContentPage.mixedOrderSections.push({
      type: 'ribbon',
      order: entry.fields['order'] as number,
      ribbon: {
        title: pageTitle,
        body: '',
        bodyArrows: tBody,
        order: entry.fields['order'] as number,
        group: entry.fields['group'] as string,
        heading: entry.fields['heading'] as string,
        subBody: entry.fields['subBody'] as string,
        sectionClass: entry.fields['sectionClass'] as string,
        noteSections: this.additionalContentPage.noteSections.filter((noteSection) => noteSection.category === entry.fields['category'])
      }
    });
  }
}
